import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { createNewFranchiseEnquiry } from "../Store/Actions/EnquiryActions";

function Franchise() {
	const [show, setShow] = useState(false);

	const [state, setState] = useState({
		name: "",
		mobileNumber: "",
		email: "",
		message: "",
	});

	const dispatch = useDispatch();

	const stateObject = useSelector((state) => state.enquiry);

	const onChangeHandler = (e) => {
		setState({ ...state, [e.target.name]: e.target.value });
	};

	let errors = [];
	if (typeof stateObject.errors !== "undefined") {
		stateObject.errors.map((item) => (errors[item.param] = item.msg));
	}

	const submitForm = (e) => {
		e.preventDefault();

		const data = { ...state };
		dispatch(createNewFranchiseEnquiry(data));
	};

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	return (
		<>
			<button
				onClick={handleShow}
				className="!bg-gradient-to-r !from-green-500 !to-blue-500 !text-white !px-8 !py-4 !rounded-full !text-lg !font-bold hover:!shadow-xl transform hover:!scale-105 !transition-all !duration-300"
			>
				🚀 Start Your Franchise Journey
			</button>

			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Send us a Message</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={submitForm}>
						<div className="grid grid-cols-1 gap-2">
							<div className="bg-white rounded-3xl px-4 py-2 shadow-xl">
								<div className="mb-6">
									<label className="block !text-sm font-medium !text-gray-700 mb-2">
										Name
									</label>
									<input
										name="name"
										onChange={onChangeHandler}
										type="text"
										className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
										placeholder="Enter your name"
									/>
								</div>
								<div className="mb-6">
									<label className="block !text-sm font-medium !text-gray-700 mb-2">
										Email Address
									</label>
									<input
										type="email"
										name="email"
										onChange={onChangeHandler}
										className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
										placeholder="Enter your email"
									/>
								</div>

								<div className="mb-6">
									<label className="block !text-sm font-medium !text-gray-700 mb-2">
										Mobile Number
									</label>
									<input
										type="text"
										name="mobileNumber"
										onChange={onChangeHandler}
										className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
										placeholder="Enter your mobile number"
									/>
								</div>

								<div>
									<label className="block !text-sm font-medium !text-gray-700 mb-2">
										Message
									</label>
									<textarea
										name="message"
										onChange={onChangeHandler}
										rows="4"
										className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
										placeholder="Tell us how we can help you!"
									></textarea>
								</div>
								<Button
									variant="default"
									type="submit"
									className="!w-full my-4 !bg-gradient-to-r !from-pink-500 !to-purple-500 !text-white py-3 !rounded-2xl !font-bold hover:!shadow-lg !transform hover:!scale-105 !transition-all !duration-300"
								>
									{stateObject.PROCESSING
										? "Submitting..."
										: "Submit 📨"}
								</Button>
								<div className="text-center">
									{stateObject.REQUEST_SUCCESS && (
										<div className="bg-gradient-to-r from-green-400 via-green-500 to-green-700 text-white rounded-2xl px-4 py-2 shadow-lg">
											{stateObject.message ||
												"Enquiry submitted successfully!"}
										</div>
									)}
									{stateObject.REQUEST_FAILED && (
										<div className="bg-red-400 text-white rounded-xl px-4 py-2 shadow-lg">
											{stateObject.message ||
												"Failed to submit enquiry."}
										</div>
									)}
								</div>
							</div>
						</div>
					</Form>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default Franchise;
